<template>
    <van-dialog
        v-model="visibleDialog"
        :title="title"
        theme='round'
        :confirmButtonText="confirmButtonText || '确认'"
        :confirmButtonColor="confirmButtonColor || '#FF7A45'"
        :cancelButtonText="cancelButtonText || '取消'"
        :cancelButtonColor="cancelButtonColor || '#000000'"
        :showConfirmButton='showConfirmButton'
        @confirm='onConfirm'
        show-cancel-button
    >
        <slot></slot>
    </van-dialog>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        confirmButtonText: {
            type: String,
            default: '确认'
        },
        confirmButtonColor: {
            type: String,
            default: '#FF7A45'
        },
        cancelButtonText: {
            type: String,
            default: '取消'
        },
        cancelButtonColor: {
            type: String,
            default: '#000000'
        },
        visibleShow: {
            type: Boolean,
            default: false
        },
        showConfirmButton: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        visibleDialog: {
            get () {
                return this.visibleShow
            },
            set () {
                this.$emit('update:visibleShow')
            }
        }
    },
    methods: {
        onConfirm () {
            this.$emit('onConfirm')
        }
    }
}
</script>

<style lang="scss" scoped>
    /deep/ .van-dialog{
        border-radius: 20px;
    }
    /deep/ .van-dialog__content{
        padding: 32px 44px 56px;
        .price{
            text-align: center;
            color: #333333;
            font-size: 40px;
            font-weight: 400;
            margin-bottom: 32px;
        }
        .content{
            font-size: 28px;
            color: #666666;
            font-weight: 400;
        }
        .openMessage{
            font-size: 32px;
            text-align: center;
            color: #000000;
            padding: 68px 106px 27px;
        }
    }
</style>